import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import CustomSelect from "../../../../../shared/components/select/CustomSelect";
import {
  electricityBackupOptions,
  EMPTY_STRING,
  featureCategories,
  flooringTypeOptions,
  propertViewOptions,
} from "../../../../../constants";
import { getOptionsFromEnums } from "../../../../../shared/utility";

const MainFeaturesForm = ({ allMustHaveAmmenities }) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useFormContext();

  const featureIds = watch("amenity.featureIds");

  useEffect(() => {
    if (featureIds === false) {
      setValue("amenity.featureIds", []);
    }

    // eslint-disable-next-line
  }, [featureIds, setValue]);

  return (
    <div className="main-container-form">
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="select-container">
            <label>Flooring Type:</label>
            <CustomSelect
              isClearable={false}
              defaultStyle={false}
              name="amenity.flooringType"
              options={getOptionsFromEnums(flooringTypeOptions)}
              showError={false}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="select-container">
            <label>Electricity Backup:</label>
            <CustomSelect
              isClearable={false}
              defaultStyle={false}
              name="amenity.electricityBackup"
              options={getOptionsFromEnums(electricityBackupOptions)}
              showError={false}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="select-container">
            <label>Built in Year:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors.amenity?.builtInYear
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="Enter Build Year"
              {...register("amenity.builtInYear")}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="select-container">
            <label>Parking Spaces:</label>
            <input
              type="text"
              className={`create-list-input ${
                errors.amenity?.parkingSpace
                  ? "border border-danger"
                  : EMPTY_STRING
              }`}
              placeholder="Parking Spaces"
              {...register("amenity.parkingSpace")}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="select-container">
            <label>Property View:</label>
            <CustomSelect
              isClearable={false}
              defaultStyle={false}
              name="amenity.propertyView"
              options={getOptionsFromEnums(propertViewOptions)}
              showError={false}
            />
          </div>
        </div>
      </div>
      <div className="row">
        {errors?.amenity?.featureIds && (
          <div className="error mt-2">
            {errors?.amenity?.featureIds.message}
          </div>
        )}
        {allMustHaveAmmenities
          ?.filter((feature) => feature.category === featureCategories.MAIN)
          .map((feature) => (
            <div className="col-12 col-sm-6" key={feature.id}>
              <Form.Check
                className="mb-2"
                name="mainFeatures"
                type="checkbox"
                label={feature.title}
                value={feature.id}
                onChange={(e) => {
                  const updatedValues = e.target.checked
                    ? [
                        ...(getValues("amenity.featureIds") || []),
                        Number(e.target.value),
                      ]
                    : (getValues("amenity.featureIds") || []).filter(
                        (id) => id !== Number(e.target.value)
                      );

                  setValue("amenity.featureIds", updatedValues, {
                    shouldValidate: true,
                  });
                }}
                checked={(getValues("amenity.featureIds") || []).includes(
                  feature.id
                )}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allMustHaveAmmenities: state.homeReducer.allMustHaveAmmenities,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainFeaturesForm);
